export enum GapiLicense {
    AcquiringCCProccessing = 'AcquiringCCProccessing', // Payment Active License
    ExternalConsumerPortal = 'ExternalConsumerPortal'
}

// Typing for the enum
export type GapiLicenseType = keyof typeof GapiLicense;
